// Copyright © 2021 React Training LLC. All rights reserved.
import { matchRoutes } from 'react-router-dom';
import { createClientRoute } from './routes.js';

// TODO: export/import from react-router-dom
function createClientMatches(matches, elementType) {
  return matches.map(match => ({ ...match,
    route: createClientRoute(match.route, elementType)
  }));
}
function matchClientRoutes(routes, location) {
  let matches = matchRoutes(routes, location);
  if (!matches) return null;
  return matches.map(match => ({
    params: match.params,
    pathname: match.pathname,
    route: match.route
  }));
}

export { createClientMatches, matchClientRoutes };
